// extracted by mini-css-extract-plugin
export var leftAlign = "_2g-2";
export var popper = "_2g-0";
export var subtitle = "_2g-1";